import React from 'react';
import styles from './Header.module.scss';
import Toolbar from '../../ui/Toolbar/Toolbar';
import MainNav from '../../ui/MainNav/MainNav';
import CompanySelect from '../CompanySelect/CompanySelect';
import BtnOpenForm from '../../ui/BtnOpenForm/BtnOpenForm';
import PermitFilterBtn from '../PermitFilterBtn/PermitFilterBtn';
import useTransportPermitsMatch from '../../hooks/useTransportPermitsMatch';
import { links } from '../../constants/links';
import Search from '../Search/Search';
import LimitsPermitBtn from '../LimitsPermitBtn/LimitsPermitBtn';

const Header = () => {
  const math = useTransportPermitsMatch();

  const isPermitsPage = math?.params?.page === links.permits;

  return (
    <Toolbar isHeader background="light" className={styles.toolbar}>
      <MainNav />
      <div className={styles.rBlock}>
        <Search />
        <BtnOpenForm />
        <CompanySelect />
        {isPermitsPage && (
          <>
            <LimitsPermitBtn />
            <PermitFilterBtn />
          </>
        )}
      </div>
    </Toolbar>
  );
};

export default Header;
